/* eslint-disable no-unused-expressions */
import React, {useCallback, useContext, useEffect, useRef} from "react";
import {DialogContent} from "@mui/material";
import {Link} from "react-router-dom";
import {
    AuthButtons, CloseIcon,
    Dialog,
    DialogSubtitle,
    DialogTitle,
    Divider,
    ErrorMessage, FacebookButton, ForgotPassword, GoogleButton,
    LoginButton,
    LoginForm,
    LoginFormInput
} from "./styles";
import {Trans, useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {authActions} from "../../../../store/slices/auth/authSlice";
import {selectLoginError} from "../../../../store/slices/auth/selectors";
import {useFormik} from "formik";
import {getLoginSchemaObject} from "../../../../utils/validations";
import {reservationActions} from "../../../../store/slices/reservation/reservationSlice";
import close from '../../../../assets/images/reservation/close.svg';
import lock from '../../../../assets/images/reservation/lock.svg';
import google from '../../../../assets/images/reservation/google-icon.svg';
import facebook from '../../../../assets/images/reservation/facebook-icon.svg';
import PropTypes from "prop-types";
import {AuthContext} from "../../../../context/AuthProvider";

const LoginDialog = props => {
    const {open, force, onClose, email} = props;
    const {t} = useTranslation();
    const {signIn, signInGoogleAccount, signInFacebookAccount} = useContext(AuthContext);
    const error = useSelector(selectLoginError);
    const dispatch = useDispatch();
    const passwordRef = useRef();

    const onSuccess = force ? () => {
        dispatch(reservationActions.createReservation());
    } : undefined;

    const formik = useFormik({
       initialValues: {
           email: email || '',
           password: ''
       },
       enableReinitialize: true,
       validationSchema: getLoginSchemaObject(t),
       onSubmit: values => {
           signIn({email: values.email, password: values.password}).then(() => {
                dispatch(authActions.loginSuccess());
                dispatch(reservationActions.setMail(values.email));
                onSuccess();
                onClose();
           }).catch(() => {
               dispatch(authActions.loginFailure());
           });
           // dispatch(authActions.loginWithUsername({username: values.email, password: values.password, onSuccess}));
       }
    });

    useEffect(() => {
        if(email) {
            formik.setFieldValue('email', email);
            passwordRef.current?.focus();
        }
    }, [email]);

    useEffect(() => {
        if(!open) {
            dispatch(authActions.setLoginError(undefined));
        }
    }, [open])

    const loginWithGoogle = () => {
        signInGoogleAccount({ onError: console.log }).then(user => {
            dispatch(authActions.loginSuccess());
            dispatch(reservationActions.setMail(user.email));
            onSuccess();
            onClose();
        }).catch(() => {
            dispatch(authActions.loginFailure());
        });
        // dispatch(authActions.loginWithGoogle({onSuccess}));
    }
    const loginWithFacebook = () => {
        signInFacebookAccount({onError: console.log}).then(user => {
            dispatch(authActions.loginSuccess());
            dispatch(reservationActions.setMail(user.email));
            onSuccess();
            onClose();
        }).catch(() => {
            dispatch(authActions.loginFailure());
        });
        // dispatch(authActions.loginWithFacebook({onSuccess}));
    };

    const handleForgotPasswordClick = () => {
        window.location.replace(`${window.location.origin}/en/forget-password`);
    };


    return <Dialog open={open || force} onClose={onClose}>
        <DialogContent>
            <DialogTitle>{t('LOGIN_DIALOG_TITLE')}</DialogTitle>
            <DialogSubtitle>{force ? <Trans i18nKey="ALREADY_REGISTERED">
                a<Link to="https://www.pickapier.com" target="_blank">b</Link>c
            </Trans> : t('LOGIN_DIALOG_SUBTITLE')}</DialogSubtitle>
            <LoginForm onSubmit={e => {
                e.preventDefault();
                formik.submitForm();
            }}>
                <LoginFormInput
                    pad={!formik.errors.email}
                    placeholder={t('EMAIL_PLACEHOLDER') || ''}
                    value={formik.values.email}
                    onChange={e => {
                        formik.setFieldValue('email', e.target.value);
                        dispatch(authActions.setLoginError(undefined));
                    }}
                    type="email"
                />
                {formik.errors.email && <ErrorMessage>{formik.errors.email}</ErrorMessage>}
                <LoginFormInput
                    ref={passwordRef}
                    pad={!formik.errors.password}
                    placeholder={t('PASSWORD_PLACEHOLDER') || ''}
                    value={formik.values.password}
                    onChange={e => {
                        formik.setFieldValue('password', e.target.value);
                        dispatch(authActions.setLoginError(undefined));
                    }}
                    type="password"
                />
                {formik.errors.password && <ErrorMessage>{formik.errors.password}</ErrorMessage>}
                {error && <ErrorMessage>{t(error)}</ErrorMessage>}
                <LoginButton onClick={formik.submitForm}>
                    <img src={lock} alt="login" />
                    <span>{t('LOGIN')}</span>
                </LoginButton>
                <ForgotPassword>
                <span onClick={handleForgotPasswordClick} style={{textDecoration: 'none', color: "inherit", cursor:"pointer"}}>
                    {t('FORGOT_PASSWORD')}
                </span>
                    
                </ForgotPassword>
                <button type="submit" style={{visibility: "hidden"}} />
            </LoginForm>
            <Divider><span>{t('OR_LOGIN_WITH')}</span></Divider>
            <AuthButtons>
                <GoogleButton onClick={loginWithGoogle} id="recaptcha-container">
                    <img src={google} alt="google"/>
                    <span>{t('GOOGLE')}</span>
                </GoogleButton>
                <FacebookButton onClick={loginWithFacebook} >
                    <img src={facebook} alt="facebook" />
                    <span>{t('FACEBOOK')}</span>
                </FacebookButton>
            </AuthButtons>
            <div id="recaptcha-container-id"></div>
            <CloseIcon src={close} onClick={onClose}></CloseIcon>
        </DialogContent>
    </Dialog>
}

LoginDialog.propTypes = {
    open: PropTypes.bool,
    force: PropTypes.bool,
    email: PropTypes.string,
    onClose: PropTypes.func,
}

export default LoginDialog;
